import React, { useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import SectionTitle from '../sectionTitle/SectionTitle';

const messages = [
    {
        role: 'Founding Director',
        name: 'Mrs. Muqaddassa Ayyaz',
        icon: 'icon-award-fill',
        short: 'I established this institution with a clear vision: to transform every individual into an extraordinary leader.',
        full: 'As the Founding Director of Green Cap High School, I established this institution with a clear vision: to transform every individual into an extraordinary leader. By the grace of Almighty Allah, over the years we have remained committed to this mission, striving continuously to nurture our students into confident, capable, and responsible leaders of the future.\n\nEducation, to us, is not only about academic success but about shaping character and broadening horizons. To our students, I would like to say: believe in your potential and take pride in your achievements. Remember, every task you undertake reflects who you are—so always perform your work with excellence and integrity.\n\nI extend my sincere gratitude to our parents for their trust and confidence in our institution. Please be assured that your children are in safe and caring hands. Together, we will continue to build a brighter future and make you proud.'
    },
    {
        role: "Director's Message",
        name: 'Green Cap High School',
        icon: 'icon-user-fill',
        short: 'For the past 20 years, Green Cap High School has stood as a symbol of commitment, integrity, and educational excellence.',
        full: 'For the past 20 years, Green Cap High School has stood as a symbol of commitment, integrity, and educational excellence. Established with a clear vision to serve our community, our mission has always been to fulfill the evolving educational needs of society while shaping the future leaders of Pakistan.\n\nWe take immense pride in our journey and the trust placed in us by thousands of families. Today, with a strong network of more than 9,000 alumni, our graduates are making meaningful contributions across Pakistan and around the world. Their achievements reflect the values, discipline, and knowledge they gained during their time at Green Cap High School.\n\nAt Green Cap High School, we believe that education is not just about learning, it is about building character, inspiring ambition, and creating opportunities. Together, we will continue to shape bright minds and a stronger future for Pakistan.'
    },
    {
        role: "Principal's Message",
        name: 'Green Cap High School',
        icon: 'icon-graduation-hat',
        short: 'Returning to serve this institution is not just a professional role for me; it is a privilege and a commitment to give back.',
        full: 'It is a matter of great pride and honor for me to serve as the Principal of Green Cap High School—an institution that has played a defining role in shaping my academic and personal journey. As an alumnus of this esteemed school, I carry a deep sense of connection, responsibility, and gratitude. Returning to serve this institution is not just a professional role for me; it is a privilege and a commitment to give back to the place that helped shape who I am today.\n\nGreen Cap High School has, for over two decades, maintained a strong tradition of academic excellence, character building, and community service. Our focus remains on providing a balanced education—one that nurtures intellectual growth, moral values, and leadership qualities.\n\nI firmly believe that our students are the future of Pakistan, and it is our responsibility to guide them with sincerity, care, and vision. I am truly honored to be part of this institution—once as a student, and now as its principal.'
    }
];

const MessageCard = ({ data }) => {
    const [expanded, setExpanded] = useState(false);
    const paragraphs = data.full.split('\n\n');

    return (
        <div className="service-card service-card-3 text-left shape-bg-1 bg-grey" style={{ height: '100%' }}>
            <div className="inner" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div className="icon">
                    <i className={data.icon}></i>
                </div>
                <div className="content" style={{ flex: 1 }}>
                    <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--color-secondary)', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>
                        {data.role}
                    </span>
                    <h6 className="title">{data.name}</h6>

                    {!expanded ? (
                        <>
                            <p className="description" style={{ fontStyle: 'italic' }}>"{data.short}"</p>
                            <div className="read-more-btn mt--20">
                                <button
                                    className="btn-transparent sm-size heading-color"
                                    onClick={() => setExpanded(true)}
                                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600', color: 'var(--color-primary)' }}
                                >
                                    Read Full Message <i className="icon-arrow-right-line-right"></i>
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            {paragraphs.map((para, i) => (
                                <p key={i} className="description" style={{ marginBottom: '12px' }}>{para}</p>
                            ))}
                            <div className="read-more-btn mt--10">
                                <button
                                    className="btn-transparent sm-size heading-color"
                                    onClick={() => setExpanded(false)}
                                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600', color: 'var(--color-primary)' }}
                                >
                                    Show Less <i className="icon-arrow-right-line-right"></i>
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const AboutUsOneService = () => {
    return (
        <div className="eduvibe-about-us-one-service edu-service-area edu-section-gap bg-color-white">
            <div className="container eduvibe-animated-shape">
                <div className="row">
                    <div className="col-lg-12">
                        <SectionTitle
                            classes="text-center"
                            slogan="Leadership"
                            title="A Message From Our Leadership"
                        />
                    </div>
                </div>

                <div className="row g-5 mt--20">
                    {messages.map((msg, i) => (
                        <ScrollAnimation
                            key={i}
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}
                            className="col-lg-4 col-md-6 col-12"
                        >
                            <MessageCard data={msg} />
                        </ScrollAnimation>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AboutUsOneService;
